module.exports = __webpack_public_path__ + "static/media/aloa_small_line.299256a0.png";